import { Injectable, OnInit } from "@angular/core";
import { UiMessage } from "app/models/ui-message";
import { RxStompService } from "../rxstomp.service";
import { UiNotificationService } from "./ui-notification-service";
import { UiActionService } from "./ui-action-service";
import { map } from "rxjs";
import { Log } from "app/core/logging/log";

@Injectable({ providedIn: 'root' })
export class UiMessageService {

  constructor(
    private rxStompService: RxStompService,
    private notification: UiNotificationService,
    private action: UiActionService
  ) { }


  subscribe(): void {
    Log.debug('UiMessageService subscribe');
    this.rxStompService.watch('/user/queue/updated-server')
    .pipe(map(msg => JSON.parse(msg.body) as UiMessage))
    .subscribe(msg => this.route(msg));
  }

  private route(msg: UiMessage): void {
    Log.debug('UiMessage', {msg});
    switch (msg.type) {

      case 'ui.notification':
        this.notification.handle(msg.payload);
        break;

      case 'ui.action':
        this.action.handle(msg.payload);
        break;

      case 'ui.batch':
        msg.payload.messages.forEach((m: UiMessage) => this.route(m));
        break;
    }
  }
}
